/* ==========================================================================
   Customise wizard — U&S Clothing
   assets/customise-wizard.js

   Reads the JSON config printed by snippets/customise-wizard.liquid, replaces
   the product page's Add to cart with a Customise button, runs the step flow,
   then posts the main item plus any paid print-location add-ons to the cart.
   ========================================================================== */
(function () {
  'use strict';

  /* "Left Chest" means the LEFT SIDE OF THE SHIRT AS WORN, which is on the
     viewer's right when looking at the front. Flip this to false if the
     client ever means "left as you look at it" instead — nothing else
     needs to change. */
  var LEFT_MEANS_AS_WORN = true;

  var LAYOUTS = [
    { id: 'text-above',  label: 'Text above image' },
    { id: 'image-above', label: 'Image above text' },
    { id: 'text-over',   label: 'Text over image'  }
  ];
  var TEXT_LABEL = 'Text to print';
  var TEXT_MAX   = 40;

  /* Used only when Theme settings → Customisation → Font list is empty. */
  var DEFAULT_FONTS = [
    'Anton | Bold display',
    'Bebas Neue | Condensed caps',
    'Oswald:600 | Condensed',
    'Montserrat:700 | Clean sans',
    'Playfair Display:700 | Elegant serif',
    'Lobster | Retro script',
    'Pacifico | Casual script',
    'Dancing Script:700 | Flowing script',
    'Great Vibes | Formal script',
    'Permanent Marker | Handwritten',
    'Bangers | Comic'
  ];

  var FONTS = [], fontsLoaded = false;

  /* Accepted formats, one per line:
       Oswald
       Oswald:600
       Oswald | Condensed
       Arial Rounded = Varela Round | Rounded sans
       Arial Rounded = Varela Round:600 | Rounded sans

     The part before "=" is what the shopper sees and what goes on the order.
     The part after it is the web font actually loaded. That matters here
     because most of the client's list are embroidery machine fonts that do
     not exist as web fonts, so the preview uses the closest match while the
     order still says the real name. A line we cannot read is skipped rather
     than breaking the picker. */
  function parseFonts(lines) {
    var out = [];
    (lines && lines.length ? lines : DEFAULT_FONTS).forEach(function (raw) {
      if (!raw) return;
      var parts = String(raw).split('|');
      var left  = parts[0].trim();
      var tag   = (parts[1] || '').trim();
      if (!left) return;

      var eq   = left.split('=');
      var spec = (eq.length > 1 ? eq[1] : eq[0]).trim();
      if (!spec) return;

      var bits   = spec.split(':');
      var family = bits[0].trim();
      var weight = (bits[1] || '').trim();
      if (!family) return;

      var isFile = /\.(woff2|woff|ttf|otf)$/i.test(family);

      /* With no "=", the shopper-facing name is the family without its
         weight — "Oswald:600" must not show up as "Oswald:600". */
      var display = eq.length > 1 ? eq[0].trim() : family;
      if (!display) return;

      out.push({
        name: display,
        tag: tag,
        file: isFile ? family : null,
        css: isFile
          ? "'" + display + "', sans-serif"
          : "'" + family + "', sans-serif",
        google: isFile ? null : family.replace(/\s+/g, '+') + (weight ? ':wght@' + weight : '')
      });
    });
    return out.length ? out : parseFonts(DEFAULT_FONTS);
  }

  /* Faces load when the modal first opens, never on page load — a product
     page nobody customises should not pay for them.

     Two sources are supported per line, so the list can mix both:
       - a file uploaded to the theme's assets  →  @font-face
       - a Google Fonts family name             →  stylesheet link

     Anything ending .woff2 / .woff / .ttf / .otf is treated as an uploaded
     file. That is the route to use for the client's embroidery fonts, since
     those do not exist on any web font service. */
  function loadFonts() {
    if (fontsLoaded || !FONTS.length) return;
    fontsLoaded = true;

    var faces = [], google = [];

    FONTS.forEach(function (f) {
      if (/\.(woff2|woff|ttf|otf)$/i.test(f.file || '')) {
        var fmt = /woff2$/i.test(f.file) ? 'woff2'
                : /woff$/i.test(f.file)  ? 'woff'
                : /otf$/i.test(f.file)   ? 'opentype' : 'truetype';
        faces.push("@font-face{font-family:'" + f.name + "';"
          + "src:url('" + (cfg.fontAssetBase || '') + f.file + "') format('" + fmt + "');"
          + "font-display:swap;font-weight:normal;font-style:normal}");
      } else if (f.google) {
        google.push('family=' + f.google);
      }
    });

    if (faces.length) {
      var st = document.createElement('style');
      st.textContent = faces.join('\n');
      document.head.appendChild(st);
    }
    if (google.length) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?' + google.join('&') + '&display=swap';
      document.head.appendChild(link);
    }
  }

  /* ------------------------------------------------------------------
     Font colours

     One list for embroidery and print — the client uses the embroidery
     thread chart for both. Editable in Theme settings → Customisation →
     Colour list, one per line as "Name:HEX".
     ------------------------------------------------------------------ */
  var DEFAULT_COLOURS = [
    'White:#FFFFFF','Mallard Teal:#16646B','Sky:#7FB9E0','Silver:#C8CBCC',
    'Sand:#E4D5BE','Rose Gold:#D9A08C','Red:#C8102E','Purple:#3E1F6D',
    'Purple Pansy:#7D3F98','Champagne:#E3D9B8','Black:#101010',
    'Pink:#F26FA2','Pale Blue:#3EB1E5','Orange:#E8631A','Olive Green:#2F3B15',
    'Cream:#F2ECD8','Nugget Gold:#E0A800','Neon Yellow:#F5E400','Navy:#14213D',
    'Mint:#3FBF9A','Brown:#6B3A17','Baby Pink:#F7C5D5',
    'Maroon:#6B0F1A','Magenta:#D6006E','Lilac:#8E7BC1','Light Green:#4CAF50',
    'Light Brown:#A9732F','Green:#159B4A','Light Blue:#2E9BD6','Grey:#9AA0A6',
    'Gold:#D9A520','Bright Pink:#FF3B4E','Autumn Orange:#E8781E',
    'Forest Green:#14512B','Fluorescent Lime:#8FE01A','Flamingo Pink:#FF1F8F',
    'Dark Grey:#4A4A4A','Dark Brown:#2E1A0F','Dark Gold:#C08A17',
    'Dark Blue:#123C7A','Charcoal:#2B2B2B','Bottle Green:#0F4436','Yellow:#F5D000'
  ];

  var COLOURS = [];

  function parseColours(lines) {
    var out = [];
    (lines && lines.length ? lines : DEFAULT_COLOURS).forEach(function (raw) {
      if (!raw) return;
      var i = String(raw).lastIndexOf(':');
      if (i < 1) return;
      var name = String(raw).slice(0, i).trim();
      var hex  = String(raw).slice(i + 1).trim();
      if (!name || !/^#?[0-9a-f]{3,8}$/i.test(hex)) return;
      if (hex[0] !== '#') hex = '#' + hex;
      out.push({ name: name, hex: hex });
    });
    return out.length ? out : parseColours(DEFAULT_COLOURS);
  }

  function colourByName(n) {
    for (var i = 0; i < COLOURS.length; i++) if (COLOURS[i].name === n) return COLOURS[i];
    return COLOURS[0];
  }

  function fontByName(n) {
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i].name === n) return FONTS[i];
    return FONTS[0];
  }

  var cfg = null, chosen = [], design = {}, steps = [], idx = 0, busy = false;
  var modal, body, els = {};

  /* ---------------------------------------------------------------- config */

  function readConfig() {
    var tag = document.querySelector('script[id^="CustomiseConfig-"]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); }
    catch (e) { console.warn('[customise] bad config JSON', e); return null; }
  }

  /* Metafields arrive as a boolean, a string, or a one-item text list
     depending on how the definition was set up. Treat them all the same. */
  function isTrue(v) {
    if (Array.isArray(v)) v = v[0];
    if (typeof v === 'string') return /^(true|yes|1)$/i.test(v.trim());
    return !!v;
  }

  function money(n) {
    return n > 0 ? '+£' + n.toFixed(2) : 'No extra cost';
  }

  function positionsFor(key) {
    return key === 'front' ? (cfg.frontPositions || []) : [];
  }

  /* ----------------------------------------------------------------- icons */

  var SHIRT = 'M38 10 L24 14 L8 32 L22 42 L24 92 Q50 96 76 92 L78 42 L92 32 L76 14 L62 10 Q50 22 38 10 Z';

  function shirt(o) {
    o = o || {};
    var m = '';
    if (o.sleeve === 'left')  m += '<path d="M24 14 L8 32 L22 42 Z" fill="currentColor" opacity=".22"/>';
    if (o.sleeve === 'right') m += '<path d="M76 14 L92 32 L78 42 Z" fill="currentColor" opacity=".22"/>';
    if (o.dot) {
      var x = o.dot[0], y = o.dot[1], r = o.r || 5;
      if (o.big) m += '<rect x="' + (x - 17) + '" y="' + (y - 14) + '" width="34" height="28" rx="3" fill="currentColor" opacity=".16"/>';
      m += '<circle cx="' + x + '" cy="' + y + '" r="' + (r + 3.5) + '" fill="currentColor" opacity=".22"/>'
         + '<circle cx="' + x + '" cy="' + y + '" r="' + r + '" fill="currentColor"/>';
    }
    return '<svg viewBox="0 0 100 100" fill="none" aria-hidden="true" style="color:rgb(var(--color-button))">'
      + '<path d="' + SHIRT + '" fill="#fff" stroke="#111827" stroke-width="2.4" stroke-linejoin="round"/>'
      + (o.back ? '' : '<path d="M38 10 Q50 22 62 10" stroke="#111827" stroke-width="2.4" fill="none"/>')
      + m + '</svg>';
  }

  /* As-worn left sits on the viewer's right. */
  var LX = LEFT_MEANS_AS_WORN ? 64 : 36;
  var RX = LEFT_MEANS_AS_WORN ? 36 : 64;

  /* Keys are lowercase so lookups survive any spelling or casing the
     metafield happens to use. */
  var ICON = {
    'front':        shirt({ dot: [50, 50], r: 6, big: true }),
    'back':         shirt({ back: true, dot: [50, 48], r: 6, big: true }),
    'left-sleeve':  shirt({ sleeve: LEFT_MEANS_AS_WORN ? 'right' : 'left',  dot: [LEFT_MEANS_AS_WORN ? 84 : 16, 34], r: 4 }),
    'right-sleeve': shirt({ sleeve: LEFT_MEANS_AS_WORN ? 'left'  : 'right', dot: [LEFT_MEANS_AS_WORN ? 16 : 84, 34], r: 4 }),
    'left chest':   shirt({ dot: [LX, 38], r: 4.5 }),
    'right chest':  shirt({ dot: [RX, 38], r: 4.5 }),
    'centre':       shirt({ dot: [50, 52], r: 6, big: true })
  };
  ICON['center'] = ICON['centre'];   /* the metafield says "Center" */
  ICON['left sleeve']  = ICON['left-sleeve'];
  ICON['right sleeve'] = ICON['right-sleeve'];

  function iconFor(name) {
    if (!name) return ICON.front;
    return ICON[String(name).toLowerCase().trim()] || ICON.front;
  }

  function layoutIcon(id) {
    var frame = '<rect x="20" y="20" width="60" height="60" rx="4" fill="#fff" stroke="#111827" stroke-width="2.4"/>';
    var t = function (y) { return '<rect x="30" y="' + y + '" width="40" height="6" rx="3" fill="currentColor" opacity=".6"/>'; };
    var i = function (y) { return '<rect x="30" y="' + y + '" width="40" height="24" rx="3" fill="currentColor" opacity=".22"/>'; };
    var inner = id === 'text-above'  ? t(32) + i(46)
              : id === 'image-above' ? i(30) + t(62)
              : i(38) + '<rect x="30" y="46" width="40" height="7" rx="3.5" fill="currentColor" opacity=".85"/>';
    return '<svg viewBox="0 0 100 100" fill="none" aria-hidden="true" style="color:rgb(var(--color-button))">' + frame + inner + '</svg>';
  }

  /* ----------------------------------------------------------------- steps */

  function contentType() {
    if (cfg.allowText && cfg.allowImage) return 'both';
    return cfg.allowText ? 'text' : 'image';
  }

  /* Step order, as the client specified:
       1  size and colour
       2  where to print
       3  text / image, with font and colour
       4  position on that location
       5  review

     Position now follows the artwork rather than preceding it — the shopper
     decides what to print before deciding where on the garment it sits. */
  function buildSteps() {
    steps = [];
    if ((cfg.options || []).length) steps.push({ kind: 'variant' });
    steps.push({ kind: 'locations' });

    chosen.forEach(function (key) {
      var d = design[key] || (design[key] = { text: '', font: FONTS[0] && FONTS[0].name });
      if (!d.font) d.font = FONTS[0] && FONTS[0].name;
      if (!d.colour) d.colour = defaultColourName();
      d.type = contentType();

      steps.push({ kind: 'content', loc: key });

      var pos = positionsFor(key);
      if (pos.length > 1) steps.push({ kind: 'position', loc: key });
      else d.position = pos[0] || null;
    });

    steps.push({ kind: 'review' });
  }

  /* Black is the common thread, so it saves a click. Resolved by name and
     guarded, because an empty or renamed colour list must not stop the step
     being built — that would leave the modal stuck with unresponsive cards. */
  function defaultColourName() {
    if (!COLOURS.length) return '';
    for (var i = 0; i < COLOURS.length; i++) {
      if (COLOURS[i].name === 'Black') return COLOURS[i].name;
    }
    return COLOURS[0].name;
  }

  function locByKey(k) {
    for (var i = 0; i < cfg.locations.length; i++) if (cfg.locations[i].key === k) return cfg.locations[i];
    return null;
  }

  /* ---------------------------------------------------------------- render */

  /* ------------------------------------------------------- live preview */

  /* Print zones as coordinates on the garment drawing. */
  var ZONES = {
    'left chest':  { x: LEFT_MEANS_AS_WORN ? 64 : 36, y: 36, w: 17, h: 14 },
    'right chest': { x: LEFT_MEANS_AS_WORN ? 36 : 64, y: 36, w: 17, h: 14 },
    'centre':      { x: 50, y: 52, w: 38, h: 31 },
    'center':      { x: 50, y: 52, w: 38, h: 31 }
  };
  var SLEEVE_ZONE = { x: 84, y: 33, w: 12, h: 10 };

  function zoneFor(locKey, position) {
    if (locKey.indexOf('sleeve') > -1) {
      var z = { x: SLEEVE_ZONE.x, y: SLEEVE_ZONE.y, w: SLEEVE_ZONE.w, h: SLEEVE_ZONE.h };
      var onLeftOfImage = (locKey.indexOf('left') > -1) !== LEFT_MEANS_AS_WORN;
      z.x = onLeftOfImage ? 16 : 84;
      return z;
    }
    if (locKey === 'back') return { x: 50, y: 50, w: 40, h: 31 };
    return ZONES[String(position || 'centre').toLowerCase()] || ZONES.centre;
  }

  /* Front and back are drawn differently — an open crew neckline versus a
     filled collar band and yoke seam — so the side reads at a glance. */
  function garment(side, art) {
    var neck = side === 'back'
      ? '<path d="M38 10 Q50 17 62 10" stroke="#111827" stroke-width="2.4" fill="#E8EDF3"/>'
        + '<path d="M26 24 Q50 30 74 24" stroke="#CBD5E1" stroke-width="1.6" fill="none"/>'
      : '<path d="M38 10 Q50 22 62 10" stroke="#111827" stroke-width="2.4" fill="none"/>';

    return '<svg viewBox="0 0 100 106" fill="none">'
      + '<path d="' + SHIRT + '" fill="#fff" stroke="#111827" stroke-width="2.4" stroke-linejoin="round"/>'
      + neck + (art || '')
      + '<text x="50" y="103" text-anchor="middle" font-size="6.2" font-weight="700"'
      + ' letter-spacing="1.5" fill="#111827" font-family="' + "var(--font-body-family)" + '">'
      + (side === 'back' ? 'BACK' : 'FRONT') + '</text></svg>';
  }

  function artwork(Z, text, imgUrl, layout, fontCss, colour) {
    var x0 = Z.x - Z.w / 2, y0 = Z.y - Z.h / 2;
    var FF   = fontCss || 'sans-serif';
    var FILL = colour ? colour.hex : 'rgb(var(--color-button))';
    var out = '<rect x="' + x0 + '" y="' + y0 + '" width="' + Z.w + '" height="' + Z.h + '" rx="1.5"'
      + ' fill="none" stroke="rgb(var(--color-button))" stroke-width="0.8"'
      + ' stroke-dasharray="2.4 2" opacity=".55"/>';

    var hasImg = !!imgUrl, hasTxt = !!(text && text.trim());
    var pad = Z.w * 0.06;
    var fs  = Math.max(3.2, Z.w * 0.16);
    var t   = escapeHtml(text || '');

    if (hasImg && hasTxt && layout === 'text-over') {
      out += '<image href="' + imgUrl + '" x="' + (x0 + pad) + '" y="' + (y0 + pad) + '"'
          + ' width="' + (Z.w - pad * 2) + '" height="' + (Z.h - pad * 2) + '" preserveAspectRatio="xMidYMid meet"/>'
          + '<text x="' + Z.x + '" y="' + (Z.y + fs * 0.35) + '" text-anchor="middle" font-size="' + fs + '"'
          + ' font-weight="700" fill="' + FILL + '" font-family="' + FF + '">' + t + '</text>';
    } else if (hasImg && hasTxt) {
      var imgH = (Z.h - pad * 3) * 0.68;
      var imgY = layout === 'image-above' ? y0 + pad : y0 + Z.h - pad - imgH;
      var txtY = layout === 'image-above' ? y0 + Z.h - pad - 1 : y0 + pad + fs;
      out += '<image href="' + imgUrl + '" x="' + (x0 + pad) + '" y="' + imgY + '"'
          + ' width="' + (Z.w - pad * 2) + '" height="' + imgH + '" preserveAspectRatio="xMidYMid meet"/>'
          + '<text x="' + Z.x + '" y="' + txtY + '" text-anchor="middle" font-size="' + fs + '"'
          + ' font-weight="700" fill="' + FILL + '" font-family="' + FF + '">' + t + '</text>';
    } else if (hasImg) {
      out += '<image href="' + imgUrl + '" x="' + (x0 + pad) + '" y="' + (y0 + pad) + '"'
          + ' width="' + (Z.w - pad * 2) + '" height="' + (Z.h - pad * 2) + '" preserveAspectRatio="xMidYMid meet"/>';
    } else if (hasTxt) {
      out += '<text x="' + Z.x + '" y="' + (Z.y + fs * 0.35) + '" text-anchor="middle" font-size="' + fs + '"'
          + ' font-weight="700" fill="' + FILL + '" font-family="' + FF + '">' + t + '</text>';
    }
    return out;
  }

  var BADGE_ICON = '<svg viewBox="0 0 100 100" fill="none">'
    + '<path d="' + SHIRT + '" fill="none" stroke="currentColor" stroke-width="7" stroke-linejoin="round"/></svg>';

  /* Only ever shows the side currently being worked on. */
  /* ==================================================================
     Preview

     Two modes. When the product has blank garment photos uploaded, the
     preview is the real garment in the shopper's chosen colour with the
     artwork laid over the print zone. Without them it falls back to the
     line drawing, which is what every product had before.

     Zones are percentages of the image rather than pixels, so one set of
     numbers works whatever size the photo is.
     ================================================================== */

  var DEFAULT_ZONES = {
    'left chest':   { x: 33, y: 30, w: 16 },
    'right chest':  { x: 67, y: 30, w: 16 },
    'centre':       { x: 50, y: 42, w: 44 },
    'center':       { x: 50, y: 42, w: 44 },
    'back':         { x: 50, y: 35, w: 46 },
    'left sleeve':  { x: 50, y: 30, w: 26 },
    'right sleeve': { x: 50, y: 30, w: 26 },
    'front':        { x: 50, y: 42, w: 44 }
  };

  var ZONES_PCT = null;

  /* "Left Chest: 33, 30, 16" per line. A line we cannot read is skipped
     rather than breaking the whole set. */
  function parseZones(lines) {
    var out = {};
    (lines || []).forEach(function (raw) {
      var m = String(raw).split(':');
      if (m.length < 2) return;
      var name = m[0].trim().toLowerCase();
      var nums = m[1].split(',').map(function (n) { return parseFloat(n); });
      if (!name || nums.length < 3 || nums.some(isNaN)) return;
      out[name] = { x: nums[0], y: nums[1], w: nums[2] };
    });
    return out;
  }

  /* A print is a little taller than it is wide, and capped so a full-width
     back print cannot run the length of the garment. */
  function zoneHeight(widthPct) {
    /* Capped at 30, not 42. A 44%-wide centre print was getting a 42% tall
       box, and half of that above the marked point put its top edge up by
       the collar. 30 keeps a centre print on the chest. */
    return Math.min(Math.max(widthPct * 1.25, 10), 30);
  }

  function zonePct(locKey, position) {
    if (!ZONES_PCT) ZONES_PCT = parseZones(cfg.zones);
    var key = String(position || locKey || '').toLowerCase().replace(/-/g, ' ');
    return ZONES_PCT[key] || DEFAULT_ZONES[key]
        || ZONES_PCT[String(locKey).toLowerCase()] || DEFAULT_ZONES[String(locKey).toLowerCase()]
        || DEFAULT_ZONES.centre;
  }

  /* Which blank photo to show: the chosen colour, the side being worked on. */
  function baseImageFor(side) {
    var imgs = cfg.baseImages || {};
    var colourName = null;
    (cfg.options || []).forEach(function (opt, i) {
      if (isColourOption(opt.name)) colourName = chosenOptions[i];
    });
    if (!colourName) return null;
    var entry = imgs[colourName];
    if (!entry) return null;
    return entry[side] || null;
  }

  function sideFor(locKey) {
    if (!locKey) return 'front';
    var k = String(locKey).toLowerCase();
    if (k.indexOf('back') > -1) return 'back';
    if (k.indexOf('sleeve') > -1) return 'sleeve';
    return 'front';
  }

  function sideLabel(side) {
    return side === 'back' ? 'Back of garment'
         : side === 'sleeve' ? 'Sleeve'
         : 'Front of garment';
  }

  /* The artwork, positioned over a real photo. */
  function photoPreview(url, Z, d, f) {
    var col = d && d.colour ? colourByName(d.colour) : null;
    var fill = col ? col.hex : '#111827';
    var parts = [];

    /* The wrapper is what the zone percentages are measured against, so it
       has to be the photo exactly. A percentage max-height on the image could
       not resolve — its parent's height came from the image itself — so the
       image overflowed its own box and every zone drifted.

       The real ratio is only known once the file has loaded, so it is written
       onto the wrapper then. Until it arrives the wrapper simply has no
       forced shape, which is harmless. */
    parts.push('<div class="cw-photo">');
    parts.push('<img src="' + url + '" alt="" class="cw-photo__garment"'
      + ' onload="this.parentNode.style.aspectRatio='
      + '(this.naturalWidth/this.naturalHeight)">');
    /* The zone used to be a fixed 38% of the garment tall whatever the print
       was, so a 16%-wide left chest got the same box as a 46%-wide back —
       and its top edge landed 19% above the marked point, up by the collar.
       Height follows the width instead; the photo is square, so a percentage
       means the same on both axes. */
    var zh = zoneHeight(Z.w);
    parts.push('<div class="cw-photo__zone" style="'
      + 'left:' + Z.x + '%;top:' + Z.y + '%;width:' + Z.w + '%;height:' + zh + '%;">');

    var img = d && d.image && (d.image.url || d.image.preview);
    var text = (d && d.text || '').trim();
    var layout = d && d.layout;

    if (img && text && layout === 'text-over') {
      /* Wrapped together so the overlay centres on the IMAGE. Laid over the
         whole zone instead, it sat above the image's middle — the artwork is
         anchored to the top of the zone and is usually shorter than it. */
      parts.push('<span class="cw-photo__over">');
      parts.push('<img src="' + img + '" class="cw-photo__art">');
      parts.push('<span class="cw-photo__text cw-photo__text--over" style="font-family:'
        + (f && f.css || 'sans-serif') + ';color:' + fill + '">' + esc(text) + '</span>');
      parts.push('</span>');
    } else {
      if (img && layout === 'image-above') parts.push('<img src="' + img + '" class="cw-photo__art">');
      if (text) parts.push('<span class="cw-photo__text" style="font-family:'
        + (f && f.css || 'sans-serif') + ';color:' + fill + '">' + esc(text) + '</span>');
      if (img && layout !== 'image-above') parts.push('<img src="' + img + '" class="cw-photo__art">');
    }

    parts.push('</div></div>');
    return parts.join('');
  }

  /* On a phone the preview is a strip; tapping it expands to a proper look.
     Desktop ignores this — the CSS only styles the open state below 900px,
     so the class is harmless there. */
  function initPreviewToggle() {
    if (!els.preview || els.preview.__cwToggle) return;
    els.preview.__cwToggle = true;

    els.preview.setAttribute('role', 'button');
    els.preview.setAttribute('tabindex', '0');
    els.preview.setAttribute('data-cw-event', 'toggle_preview');

    function toggle() {
      var open = els.preview.classList.toggle('cw-preview--open');
      els.preview.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    els.preview.addEventListener('click', toggle);
    els.preview.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  }

  /* Shrink the preview text until it fits on one line inside the print.

     A CSS font-size cannot know how long the text is, so a long line either
     wrapped to three rows and squeezed the image out, or overflowed. Measuring
     the rendered width and stepping the size down is the only way to get one
     line at whatever length the shopper types — which is also how it will be
     printed. */
  /* Shrink the preview text until it fits on one line inside the print.

     Three separate things made this harder than it looks:

       - It ran the instant the markup was written, when the garment photo
         had not loaded. The wrapper had no shape yet, so the zone measured
         0x0, the function returned early, and the text kept whatever size
         the stylesheet gave it. That is why it stayed clipped.

       - scrollWidth cannot be used. Centred text that overflows on both
         sides does not report its left overflow, so a line that is plainly
         too wide measures as fitting.

       - The face has to be loaded before measuring. The same string is wider
         in the real font than in the fallback.

     So: measure a hidden copy in the right face, and run again whenever the
     layout could have changed underneath it. */
  /* The few rules the multi-line box needs on top of .cw-input. Injected
     rather than added to customise-wizard.css so this change is one file, not
     two — .cw-input sets a fixed height and side-only padding, which on a
     textarea puts the first line hard against the top edge. */
  function multiLineStyles() {
    if (document.getElementById('cw-multiline-css')) return;
    var st = document.createElement('style');
    st.id = 'cw-multiline-css';
    st.textContent = '.cw-input--multi{'
      + 'min-height:5.2rem;height:auto;padding:1.1rem 1.2rem;'
      + 'line-height:1.35;resize:none;overflow:hidden;'
      + 'font-family:inherit;display:block;box-sizing:border-box}';
    document.head.appendChild(st);
  }

  function fitText(zone) {
    if (!zone) return;
    var el = zone.querySelector('.cw-photo__text');
    if (!el || !el.textContent.trim()) return;

    /* Text laid over the image is bounded by the IMAGE, not the print area —
       the artwork is usually narrower than the zone. */
    var overWrap = el.classList.contains('cw-photo__text--over')
      ? zone.querySelector('.cw-photo__over') : null;
    var box = overWrap || zone;

    var room = box.clientWidth;
    var tall = box.clientHeight;
    if (!room || !tall) return;      /* nothing laid out yet — a later pass catches it */

    /* The text can now carry line breaks, so it is measured line by line.

       Measured as one run it came out as wide as every line joined together,
       and the loop below shrank the font until that imaginary line fitted —
       two short lines printed at a size meant for one long one, far too
       small. What bounds the width is the WIDEST line; what bounds the
       height is how many there are. */
    var lines = String(el.textContent).split('\n');
    var lineCount = Math.max(1, lines.length);

    var probe = document.createElement('span');
    probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;'
      + 'left:-9999px;top:0;font-weight:700;';
    probe.style.fontFamily = getComputedStyle(el).fontFamily;
    document.body.appendChild(probe);

    function widthAt(px) {
      probe.style.fontSize = px + 'px';
      var widest = 0;
      for (var i = 0; i < lines.length; i++) {
        /* An empty line still has a height, but no width to measure. */
        probe.textContent = lines[i] || ' ';
        if (probe.offsetWidth > widest) widest = probe.offsetWidth;
      }
      return widest;
    }

    /* Capped by the height the text is allowed as well as by the width.

       Sized on width alone, a wide print never shrank — a centre print gave
       a 24.5px font in a box with room for about 22px, and the letters were
       cut off top and bottom. A chest print never showed it because its zone
       is narrow enough that the width forces a small font anyway.

       0.38 of the print for text with an image beside it, and a line box is
       roughly 1.3x the font size, so that is the divisor. */
    var share = overWrap ? 1 : 0.38;
    /* The height each line may take, so three lines each get a third of the
       room one line would have had. */
    var byHeight = (tall * share) / (1.3 * lineCount);
    var size = Math.min(tall * (overWrap ? 0.30 : 0.34), byHeight);
    var min = 4;
    var guard = 0;

    while (widthAt(size) > room && size > min && guard++ < 80) {
      size -= Math.max(size * 0.06, 0.5);
    }

    var tooWide = widthAt(size) > room;
    probe.remove();

    el.style.fontSize = size + 'px';
    /* pre-line keeps the shopper's own line breaks and still wraps a line
       that is too long for the print area. With one line the old behaviour
       stands, so nothing changes for the products already using it. */
    el.style.whiteSpace = lineCount > 1 ? 'pre-line' : (tooWide ? 'normal' : 'nowrap');
  }

  /* Run it now, and again once the things it depends on have arrived. */
  function fitTextWhenReady(stage) {
    if (!stage) return;
    var zone = stage.querySelector('.cw-photo__zone');
    if (!zone) return;

    var run = function () { fitText(zone); };
    run();

    Array.prototype.forEach.call(stage.querySelectorAll('img'), function (im) {
      if (im.complete) return;
      im.addEventListener('load', run, { once: true });
      im.addEventListener('error', run, { once: true });
    });

    requestAnimationFrame(run);
    setTimeout(run, 120);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    }
  }

  function paintPreview(st) {
    /* The preview now shows on every step, not only the artwork ones — the
       client asked for the garment to be visible throughout. On the early
       steps there is no artwork yet, so it shows the plain garment in the
       colour chosen so far. */
    els.preview.hidden = false;
    els.bodywrap.classList.remove('cw-body--single');

    /* On the review step there is no st.loc, so fall back to whichever
       location the shopper is previewing. */
    var key  = st.loc || (st.kind === 'review' ? reviewLoc : null);
    var d    = key ? design[key] : null;
    var side = sideFor(key);

    /* On the artwork step the position has not been chosen yet — it is the
       step after. Falling back to a built-in default put the preview
       somewhere the product's own zones never mention, so the artwork jumped
       as soon as a position was picked. Using the first position the product
       actually offers means the preview starts where it is going to end up. */
    var pos  = (d && d.position) || (key ? positionsFor(key)[0] : null);
    var Z    = zonePct(key, pos);
    var f    = d && d.font ? fontByName(d.font) : FONTS[0];
    var url  = baseImageFor(side);

    els.badge.innerHTML = BADGE_ICON + '<span>' + sideLabel(side) + '</span>';

    if (url) {
      els.stage.innerHTML = photoPreview(url, Z, d, f);
      fitTextWhenReady(els.stage);
      els.viewcap.textContent = d
        ? 'Approximate preview of your design and chosen placement.'
        : 'The garment you have selected.';
    } else {
      /* no blank photo uploaded for this colour and side */
      els.stage.innerHTML = garment(side === 'sleeve' ? 'front' : side,
        d ? artwork(zoneFor(st.loc, d.position), d.text,
                    d.image && (d.image.url || d.image.preview), d.layout,
                    f && f.css, d.colour ? colourByName(d.colour) : null) : '');
      els.viewcap.textContent = 'Approximate preview of your design and chosen placement.';
    }
  }

  function card(html, checked, onclick, track) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cw-card';
    b.setAttribute('aria-checked', !!checked);
    /* tracking hook — see the note on the trigger button */
    b.setAttribute('data-cw-event', (track && track.event) || 'select_card');
    if (track && track.value) b.setAttribute('data-cw-value', track.value);
    b.setAttribute('role', 'radio');
    b.innerHTML = html + '<span class="cw-tick">&#10003;</span>';
    b.addEventListener('click', onclick);
    return b;
  }

  /* Rebuilding the panel resets its scroll, so choosing a layout option
     half way down the artwork step threw the shopper back to the heading.
     Remember where they were and restore it, unless the step itself changed.
     Not a full re-render is the better fix, but it would mean rewriting the
     whole step renderer; this costs two lines and behaves correctly. */
  var lastStepKey = null;

  /* ------------------------------------------------------------------
     Next, while an image is uploading

     Reported from session recordings: shoppers tapped Next again and again
     during an upload and nothing happened. validate() was already refusing
     to move on — correctly, since the artwork has no URL yet — but the button
     looked exactly as it does when it works, so the only signal was a small
     line of text beside a field that may be off screen.

     The button now says what it is doing and cannot be pressed until the
     upload lands. It only takes over on the step the upload belongs to, so
     going Back to an earlier step still works normally, and it stays out of
     the way while add to cart is running, which drives the button itself.
     ------------------------------------------------------------------ */
  var uploadState = { active: false, loc: null, label: '' };

  function uploadOwnsNext() {
    if (busy || !uploadState.active) return false;
    var st = steps[idx];
    return !!st && st.kind === 'content' && st.loc === uploadState.loc;
  }

  function applyUploadUI() {
    if (!uploadOwnsNext()) return;
    els.next.disabled = true;
    els.next.textContent = uploadState.label;
  }

  function startUpload(loc) {
    uploadState = { active: true, loc: loc, label: 'Preparing image\u2026' };
    applyUploadUI();
  }

  function setUploadLabel(text) {
    uploadState.label = text;
    applyUploadUI();
  }

  function endUpload() {
    uploadState = { active: false, loc: null, label: '' };
    /* render() runs straight after every call to this and puts the real
       label and disabled state back. */
  }

  function render() {
    var st = steps[idx];

    var scroller = body.closest('.cw-panel') || body.closest('.cw-body');
    var stepKey = st.kind + ':' + (st.loc || '');
    var keepScroll = (scroller && stepKey === lastStepKey) ? scroller.scrollTop : null;
    lastStepKey = stepKey;
    var loc = st.loc ? locByKey(st.loc) : null;
    body.innerHTML = '';
    els.err.textContent = '';

    els.bar.style.width = (idx / (steps.length - 1) * 100) + '%';
    els.sub.textContent = 'Step ' + (idx + 1) + ' of ' + steps.length + (loc ? ' — ' + loc.label : '');
    els.crumbs.innerHTML = chosen.length
      ? chosen.map(function (k) {
          var l = locByKey(k);
          return st.loc === k ? '<b>' + l.label + '</b>' : l.label;
        }).join(' <span>&rsaquo;</span> ')
      : '';

    var wrap = document.createElement('div');

    if (st.kind === 'variant') {
      wrap.innerHTML =
        '<p class="cw-q">' + esc(txt('variantTitle')) + '</p>'
        + '<p class="cw-q-sub">' + esc(txt('variantSub')) + '</p>';

      (cfg.options || []).forEach(function (opt, oi) {
        var field = document.createElement('div');
        field.className = 'cw-field cw-optfield';
        field.innerHTML =
          '<label>' + esc(opt.name) + '</label>'
          + '<p class="cw-help">Selected: <b class="cw-optname">'
          + esc(chosenOptions[oi] || '') + '</b></p>'
          + '<div class="cw-opts" role="radiogroup" aria-label="' + esc(opt.name) + '"></div>';

        var row = field.querySelector('.cw-opts');
        var nameEl = field.querySelector('.cw-optname');

        opt.values.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', val === chosenOptions[oi]);
          b.setAttribute('data-cw-event', 'select_option');
          b.setAttribute('data-cw-option', opt.name);
          b.setAttribute('data-cw-value', val);

          /* Colour options are shown as swatches, the way the product page
             shows them. The theme paints those from a handleized data-color
             attribute in its own stylesheet, so reusing the attribute means
             the colours match the rest of the site with no second list to
             keep in step. */
          if (isColourOption(opt.name)) {
            /* deliberately NOT .cw-opt — that class paints a white
               background, which covered the theme's swatch colour. */
            b.className = 'cw-opt--swatch';
            b.setAttribute('data-color', handleize(val));
            b.setAttribute('title', val);
            b.setAttribute('aria-label', val);
            b.innerHTML = '<span class="cw-opt__tick" aria-hidden="true">&#10003;</span>';
          } else {
            b.className = 'cw-opt';
            b.textContent = val;
          }

          if (!valueAvailable(oi, val)) {
            b.classList.add('cw-opt--out');
            /* keep the value in the tooltip — overwriting it left a colour
               swatch with no name at all on hover */
            b.title = val + ' — not available in the size selected';
          }

          b.addEventListener('click', function () {
            chosenOptions[oi] = val;

            /* Picking a colour that the current size does not come in used to
               leave the shopper stuck on a dead combination. Seen live: the
               modal opens on XS, and eleven of seventeen colours have no XS —
               so most of the range looked sold out.

               Now the other options move to the first combination that
               actually exists for what was just picked. */
            var v = variantFor(chosenOptions);
            if (!v || !v.available) {
              var fallback = (cfg.variants || []).filter(function (cand) {
                return cand.available && cand.options[oi] === val;
              })[0];
              if (fallback) chosenOptions = fallback.options.slice();
            }

            render();
          });
          row.appendChild(b);
        });

        wrap.appendChild(field);
      });

      var v = variantFor(chosenOptions);
      var note = document.createElement('p');
      note.className = 'cw-varnote' + (v && v.available ? '' : ' cw-varnote--out');
      note.textContent = v
        ? (v.available ? 'In stock' : 'That combination is sold out')
        : 'That combination is not available';
      wrap.appendChild(note);

      els.next.disabled = !(v && v.available);
    }

    if (st.kind === 'locations') {
      wrap.innerHTML = '<p class="cw-q">' + esc(txt('locTitle')) + '</p>'
        + '<p class="cw-q-sub">' + esc(txt('locSub')) + '</p>';
      var g = document.createElement('div');
      g.className = 'cw-cards';
      g.setAttribute('role', 'group');
      cfg.locations.forEach(function (l) {
        g.appendChild(card(
          iconFor(l.key)
          + '<span class="cw-card-t">' + l.label + '</span>'
          + (l.price
              ? '<span class="cw-card-p cw-card-p--addon">'
                + '<span class="cw-tag">Add-on</span> +\u00A3' + l.price.toFixed(2) + '</span>'
              : '<span class="cw-card-p cw-free">Included</span>'),
          chosen.indexOf(l.key) > -1,
          function () {
            var i = chosen.indexOf(l.key);
            if (i > -1) chosen.splice(i, 1); else chosen.push(l.key);
            chosen.sort(function (a, b) {
              return cfg.locations.findIndex(function (x) { return x.key === a; })
                   - cfg.locations.findIndex(function (x) { return x.key === b; });
            });
            buildSteps(); render();
          },
          { event: 'select_location', value: l.label }));
      });
      wrap.appendChild(g);
    }

    if (st.kind === 'position') {
      wrap.innerHTML = '<p class="cw-q">' + esc(txt('posTitle', {loc: loc.label.toLowerCase()})) + '</p>'
        + '<p class="cw-q-sub">' + esc(txt('posSub')) + '</p>';
      var pg = document.createElement('div');
      pg.className = 'cw-cards';
      positionsFor(st.loc).forEach(function (p) {
        pg.appendChild(card(iconFor(p) + '<span class="cw-card-t">' + p + '</span>',
          design[st.loc].position === p,
          function () { design[st.loc].position = p; render(); },
          { event: 'select_position', value: p }));
      });
      wrap.appendChild(pg);
    }

    if (st.kind === 'content') {
      var d = design[st.loc];
      wrap.innerHTML = '<p class="cw-q">' + esc(txt('contentTitle', {loc: loc.label.toLowerCase()})) + '</p>'
        + '<p class="cw-q-sub">' + (d.position ? esc(d.position) + ' — ' : '') + esc(txt('contentSub')) + '</p>';
      var f = document.createElement('div');
      f.className = 'cw-fields';

      if (d.type === 'text' || d.type === 'both') {
        var row = document.createElement('div');
        row.className = 'cw-field';
        row.innerHTML = '<label for="cwText-' + st.loc + '">' + TEXT_LABEL + '</label>'
          + '<p class="cw-help">Type it exactly as you want it printed.</p>'
          + '<textarea id="cwText-' + st.loc + '" class="cw-input cw-input--multi" rows="2"'
          + ' maxlength="' + TEXT_MAX + '"'
          + ' placeholder="e.g. BROWN &middot; EST. 2024"></textarea>'
          + '<div class="cw-count"><span>' + (d.text || '').length + '</span>/' + TEXT_MAX + '</div>';
        var inp = row.querySelector('textarea'), cnt = row.querySelector('.cw-count span');
        /* Set as a value rather than written into the markup: a textarea's
           content is its text, so quotes and line breaks would both have to be
           escaped by hand, and a stray newline there shifts the whole field. */
        inp.value = d.text || '';
        multiLineStyles();

        function growText() {
          inp.style.height = 'auto';
          inp.style.height = inp.scrollHeight + 'px';
        }
        setTimeout(growText, 0);

        inp.addEventListener('input', function () {
          d.text = inp.value;
          cnt.textContent = inp.value.length;
          growText();
          paintPreview(st);            /* preview follows every keystroke */
        });
        f.appendChild(row);

        f.appendChild(fontPicker(d));
        f.appendChild(colourPicker(d));
      }

      if (d.type === 'image' || d.type === 'both') {
        var irow = document.createElement('div');
        irow.className = 'cw-field';
        irow.innerHTML = '<label>Your image</label>'
          + '<div class="cw-drop' + (d.image ? ' cw-filled' : '') + '">'
          + (d.image
              ? '<img src="' + d.image.preview + '" alt=""><strong>' + d.image.name + '</strong><small>Tap to replace</small>'
              : '<strong>Choose an image</strong><small>JPG, PNG or WEBP &middot; at least 1000px wide for a sharp print</small>')
          + '</div>'
          + '<div class="cw-progress" hidden>'
          +   '<div class="cw-progress__bar"><i></i></div>'
          +   '<p class="cw-progress__label">Uploading&hellip;</p>'
          + '</div>'
          + '<input type="file" accept="image/*" hidden>';
        var drop = irow.querySelector('.cw-drop'),
            file = irow.querySelector('input[type=file]'),
            note = irow.querySelector('.cw-progress'),
            bar  = irow.querySelector('.cw-progress__bar i'),
            lbl  = irow.querySelector('.cw-progress__label');
        drop.addEventListener('click', function () { file.click(); });
        file.addEventListener('change', function () {
          var fl = file.files[0];
          if (!fl) return;
          d.image = { name: fl.name, preview: URL.createObjectURL(fl), url: null, failed: false };
          note.hidden = false;
          bar.style.width = '0%';
          lbl.textContent = 'Preparing image…';

          /* The button takes the same message as the progress bar, because on
             a phone the bar can be scrolled out of sight while the button is
             pinned at the bottom of the modal. */
          startUpload(st.loc);

          uploadImage(fl, function (pct) {
            if (pct === null) {
              bar.style.width = '100%';
              lbl.textContent = 'Uploading…';
              setUploadLabel('Uploading…');
              return;
            }
            bar.style.width = pct + '%';
            var msg = pct < 100 ? 'Uploading… ' + pct + '%' : 'Finishing up…';
            lbl.textContent = msg;
            setUploadLabel(msg);
          }).then(function (url) {
            d.image.url = url;
            note.hidden = true;
            endUpload();
            render();
          }).catch(function () {
            note.hidden = true;
            if (d.image) d.image.failed = true;
            endUpload();
            /* The chosen file is kept, so "try again" means one tap on the
               box rather than finding the photo a second time. */
            els.err.textContent = 'That image did not upload — tap the image to try again. '
              + 'If it keeps failing, try a different photo or a stronger connection.';
            render();
          });
        });
        f.appendChild(irow);
      }

      if (d.type === 'both' && d.image) {
        var lrow = document.createElement('div');
        lrow.className = 'cw-field';
        lrow.innerHTML = '<label>How should they sit together?</label>';
        var lg = document.createElement('div');
        lg.className = 'cw-cards cw-cards--layout';
        LAYOUTS.forEach(function (l) {
          lg.appendChild(card(layoutIcon(l.id) + '<span class="cw-card-t">' + l.label + '</span>',
            d.layout === l.id, function () { d.layout = l.id; render(); },
            { event: 'select_layout', value: l.id }));
        });
        lrow.appendChild(lg);
        f.appendChild(lrow);
      } else {
        d.layout = null;
      }

      wrap.appendChild(f);
    }

    if (st.kind === 'review') {
      wrap.innerHTML = '<p class="cw-q">' + esc(txt('reviewTitle')) + '</p>'
        + '<p class="cw-q-sub">' + esc(txt('reviewSub')) + '</p>';

      /* The review step has no location of its own, so the preview had
         nothing to draw and fell back to the plain garment — which is not
         what someone checking their design wants to see. It shows the first
         location by default, and clicking a card below switches to that one. */
      if (chosen.indexOf(reviewLoc) === -1) reviewLoc = chosen[0] || null;
      var extra = 0;
      chosen.forEach(function (k) {
        var l = locByKey(k), d2 = design[k];
        extra += l.price || 0;
        var rows = [];
        if (d2.position) rows.push(['Position', d2.position]);
        /* The review is a one-line row, so a break is shown as a slash
           rather than silently closing up. The stored text keeps its real
           line break for the cart and the printed garment. */
        if (d2.text)     rows.push([TEXT_LABEL, d2.text.replace(/\s*\n+\s*/g, ' / ')]);
        if (d2.text && d2.font)   rows.push(['Font', d2.font]);
        if (d2.text && d2.colour) rows.push(['Font colour', d2.colour]);
        if (d2.image)    rows.push(['Image', d2.image.name]);
        if (d2.layout)   rows.push(['Layout', LAYOUTS.filter(function (x) { return x.id === d2.layout; })[0].label]);

        var box = document.createElement('div');
        box.className = 'cw-rev' + (k === reviewLoc ? ' cw-rev--showing' : '');
        box.setAttribute('data-cw-event', 'preview_location');
        box.setAttribute('data-cw-value', l.label);

        /* clicking anywhere on the card previews that location */
        box.addEventListener('click', function (e) {
          if (e.target.closest('[data-jump]')) return;   /* Edit has its own job */
          reviewLoc = k;
          render();
        });
        box.innerHTML = '<div class="cw-rev-h"><b>' + l.label + '</b>'
          + '<span class="cw-amt ' + (l.price ? 'cw-amt--addon' : 'cw-amt--free') + '">'
          +   (l.price ? 'Add-on +\u00A3' + l.price.toFixed(2) : 'Included')
          + '</span>'
          + '<button type="button" class="cw-edit" data-cw-event="edit_step" data-jump="' + k + '">Edit this</button></div>'
          + '<dl class="cw-rev-b">'
          + rows.map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + escapeHtml(r[1]) + '</dd>'; }).join('')
          + '</dl>';
        box.querySelector('[data-jump]').addEventListener('click', function () {
          for (var i = 0; i < steps.length; i++) if (steps[i].loc === k) { idx = i; break; }
          render();
        });
        wrap.appendChild(box);
      });
      if (extra > 0) {
        var t = document.createElement('div');
        t.className = 'cw-total';
        t.innerHTML = '<span>Add-ons for extra print locations</span><span>+\u00A3' + extra.toFixed(2) + '</span>';
        wrap.appendChild(t);
      }
    }

    body.appendChild(wrap);
    paintPreview(st);
    showPendingError();

    /* Restoring immediately did not work. body IS the scroller, so clearing
       its contents at the top of render() sets scrollTop to 0, and putting
       the old value back before the new content has laid out means the
       browser clamps it to whatever the height is at that instant — which is
       usually smaller, because images have not loaded yet.

       Restoring on the next frame, and again once the images are in, keeps
       the shopper where they were. */
    if (keepScroll !== null && !pendingError) {
      var want = keepScroll;
      var put = function () { scroller.scrollTop = want; };
      requestAnimationFrame(put);
      setTimeout(put, 60);
      Array.prototype.forEach.call(body.querySelectorAll('img'), function (im) {
        if (!im.complete) im.addEventListener('load', put, { once: true });
      });
    }
    els.back.style.visibility = idx === 0 ? 'hidden' : 'visible';
    els.next.textContent = st.kind === 'review' ? txt('addToCart') : txt('next');

    /* The variant step sets this itself, above, from whether the chosen
       combination is in stock. Every other step must clear it, or a button
       disabled during an upload stays dead after the upload finishes.
       Caught in testing: the label went back to Next but the button did not.
       applyUploadUI() below puts it back if an upload is still running. */
    if (st.kind !== 'variant') els.next.disabled = false;
    els.back.textContent = txt('back');

    /* The step a button belongs to, so a GTM tag can tell "Next on the size
       step" from "Next on the artwork step" and a funnel can be built from
       it without touching this file again. */
    els.next.setAttribute('data-cw-event', st.kind === 'review' ? 'add_to_cart' : 'next_step');
    els.next.setAttribute('data-cw-step', st.kind);
    els.next.setAttribute('data-cw-step-index', idx + 1);
    els.back.setAttribute('data-cw-event', 'previous_step');
    els.back.setAttribute('data-cw-step', st.kind);
    els.close.setAttribute('data-cw-event', 'close_personaliser');
    els.close.setAttribute('data-cw-step', st.kind);

    /* Last word on the button, so a re-render during an upload does not
       quietly turn Next back on. */
    applyUploadUI();

    body.scrollTop = 0;
  }

  /* A custom listbox, not a <select>: mobile browsers ignore font-family on
     <option>, so a native dropdown would show every font in the same face and
     defeat the whole point. */
  function fontPicker(d) {
    var wrapEl = document.createElement('div');
    wrapEl.className = 'cw-field';

    var current = fontByName(d.font);
    wrapEl.innerHTML =
      '<label>Font</label>'
      + '<p class="cw-help">Each name is shown in its own style.</p>'
      + '<div class="cw-fontpick">'
      +   '<button type="button" class="cw-fontpick__btn" aria-haspopup="listbox" aria-expanded="false">'
      +     '<span class="cw-fontpick__name" style="font-family:' + current.css + '">' + current.name + '</span>'
      +     '<span class="cw-fontpick__chev">&#9662;</span>'
      +   '</button>'
      +   '<div class="cw-fontpick__list" role="listbox" hidden></div>'
      + '</div>';

    var btn  = wrapEl.querySelector('.cw-fontpick__btn');
    var list = wrapEl.querySelector('.cw-fontpick__list');

    FONTS.forEach(function (fo) {
      var o = document.createElement('button');
      o.type = 'button';
      o.className = 'cw-fontpick__opt';
      o.setAttribute('data-cw-event', 'select_font');
      o.setAttribute('data-cw-value', fo.name);
      o.setAttribute('role', 'option');
      o.setAttribute('aria-selected', fo.name === d.font);
      o.innerHTML = '<span class="cw-fontpick__sample" style="font-family:' + fo.css + '">' + fo.name + '</span>'
        + (fo.tag ? '<span class="cw-fontpick__tag">' + fo.tag + '</span>' : '');
      o.addEventListener('click', function () {
        d.font = fo.name;
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        render();
      });
      list.appendChild(o);
    });

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var opening = list.hidden;
      list.hidden = !opening;
      btn.setAttribute('aria-expanded', String(opening));
    });
    document.addEventListener('click', function () {
      if (!list.hidden) { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    });

    return wrapEl;
  }

  /* One colour at a time — a radio group, not checkboxes. */
  function colourPicker(d) {
    var wrapEl = document.createElement('div');
    wrapEl.className = 'cw-field';

    var current = colourByName(d.colour);
    wrapEl.innerHTML =
      '<label>Font colour</label>'
      + '<p class="cw-help">Selected: <b class="cw-swatch-name">' + escapeHtml(current.name) + '</b></p>'
      + '<div class="cw-swatches" role="radiogroup" aria-label="Font colour"></div>';

    var grid = wrapEl.querySelector('.cw-swatches');
    var nameEl = wrapEl.querySelector('.cw-swatch-name');

    COLOURS.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cw-swatch';
      b.setAttribute('data-cw-event', 'select_colour');
      b.setAttribute('data-cw-value', c.name);
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', c.name === d.colour);
      b.setAttribute('aria-label', c.name);
      b.title = c.name;
      b.style.setProperty('--sw', c.hex);
      b.innerHTML = '<span class="cw-swatch__tick" aria-hidden="true">&#10003;</span>';
      b.addEventListener('click', function () {
        d.colour = c.name;
        nameEl.textContent = c.name;
        Array.prototype.forEach.call(grid.children, function (el) {
          el.setAttribute('aria-checked', el.title === c.name);
        });
        paintPreview(steps[idx]);   /* recolour the preview text immediately */
      });
      grid.appendChild(b);
    });

    return wrapEl;
  }

  /* ------------------------------------------------------------------
     Everything the shopper reads, in one place.

     Kept together so the wording can be changed without hunting through the
     render code, and so nothing is left inconsistent when it is.
     ------------------------------------------------------------------ */
  var COPY = {
    triggerButton : 'Personalise',

    variantTitle  : 'Select size & colour',
    variantSub    : 'Choose the size and colour of your product',

    locTitle      : 'Choose Your Design Placement',
    locSub        : 'Pick one or more. We\'ll set up each one in turn.',

    contentTitle  : 'Your artwork for the {loc}',
    contentSub    : 'This is exactly what we print.',

    posTitle      : 'Where on the {loc}?',
    posSub        : 'This is where your artwork will sit.',

    reviewTitle   : 'Check your design',
    reviewSub     : 'This is an approximate preview of your design and chosen placement. Standard adjustments may be made during production.',

    addToCart     : 'Add to cart',
    next          : 'Next',
    back          : 'Back'
  };

  function txt(key, vars) {
    var out = COPY[key] || '';
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        out = out.replace('{' + k + '}', vars[k]);
      });
    }
    return out;
  }

  /* Short alias. The newer code calls esc(); the original called
     escapeHtml(). One name would have been better from the start, but
     aliasing is safer than renaming fourteen call sites by hand. */
  function esc(s) { return escapeHtml(s); }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ------------------------------------------------------------ validation */

  /* What failed, so render() can highlight the field and scroll to it.
     A message at the foot of a scrolling modal is easy to miss — especially
     on a phone, where the failing field may be well off screen. */
  var pendingError = null;

  function fail(field, message) {
    pendingError = { field: field, message: message };
    els.err.textContent = message;
    render();
    return false;
  }

  function validate() {
    var st = steps[idx];
    els.err.textContent = '';
    pendingError = null;

    if (st.kind === 'variant') {
      var v = variantFor(chosenOptions);
      if (!v || !v.available) return fail('variant', 'Choose an available size and colour.');
    }

    if (st.kind === 'locations' && !chosen.length) {
      return fail('locations', 'Pick at least one place to print.');
    }

    if (st.kind === 'position' && !design[st.loc].position) {
      return fail('position', 'Choose a position.');
    }

    if (st.kind === 'content') {
      var d = design[st.loc];
      if ((d.type === 'text' || d.type === 'both') && !(d.text || '').trim()) {
        return fail('text', 'Add the text you want printed.');
      }
      if ((d.type === 'image' || d.type === 'both') && !d.image) {
        return fail('image', 'Add your image.');
      }
      if (d.image && !d.image.url) {
        return fail('image', d.image.failed
          ? 'Your image did not upload — tap it to try again.'
          : 'Your image is still uploading — one moment.');
      }
      if (d.type === 'both' && !d.layout) {
        return fail('layout', 'Choose how the text and image sit together.');
      }
    }
    return true;
  }

  /* Mark the offending field and bring it into view. Runs after render() has
     rebuilt the step, so the elements it points at are the new ones. */
  function showPendingError() {
    if (!pendingError) return;

    var sel = {
      text:      '.cw-field:has(.cw-input), .cw-input',
      image:     '.cw-drop',
      layout:    '.cw-cards--layout',
      locations: '.cw-cards',
      position:  '.cw-cards',
      variant:   '.cw-optfield'
    }[pendingError.field];

    var target = null;
    try { target = body.querySelector(sel); } catch (e) { target = null; }
    if (!target) target = body.querySelector('.cw-field, .cw-cards');
    if (!target) return;

    var host = target.closest('.cw-field') || target;
    host.classList.add('cw-invalid');

    if (!host.querySelector('.cw-required')) {
      var note = document.createElement('p');
      note.className = 'cw-required';
      note.setAttribute('role', 'alert');
      note.textContent = pendingError.message;
      host.appendChild(note);
    }

    /* scrollIntoView walks up to the nearest scrollable ancestor, which on
       desktop is .cw-panel and on a phone is .cw-body. Scrolling the right
       one explicitly is the only way this lands reliably in both. */
    /* Deferred for the same reason as the scroll restore above — the panel
       has just been rebuilt and is not its final height yet, so scrolling
       straight away lands short. */
    var scroller = body.closest('.cw-panel') || body.closest('.cw-body') || body;
    requestAnimationFrame(function () {
      var offset = host.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
      var target = scroller.scrollTop + offset - (scroller.clientHeight / 2) + (host.offsetHeight / 2);
      try { scroller.scrollTo({ top: target, behavior: 'smooth' }); }
      catch (e) { scroller.scrollTop = target; }
    });

    var input = host.querySelector('input[type="text"], textarea');
    if (input) setTimeout(function () { input.focus(); }, 320);

    /* clear it as soon as they do something about it */
    host.addEventListener('input', clearPendingError, { once: true });
    host.addEventListener('click', clearPendingError, { once: true });
  }

  function clearPendingError() {
    pendingError = null;
    els.err.textContent = '';
    Array.prototype.forEach.call(body.querySelectorAll('.cw-invalid'), function (el) {
      el.classList.remove('cw-invalid');
    });
    Array.prototype.forEach.call(body.querySelectorAll('.cw-required'), function (el) {
      el.remove();
    });
  }

  /* ---------------------------------------------------------------- upload */

  /* XHR rather than fetch, because fetch cannot report upload progress.
     A phone photo is often 3-5MB and on mobile data that takes long enough
     that a silent spinner reads as "stuck" — which is exactly what was being
     reported. The file is sent at full resolution: dropping quality to make
     the bar move faster would cost print sharpness, which matters more. */
  /* ------------------------------------------------------------------
     Uploading

     Reported: on a phone the image often only lands after several tries.
     Four things in the old path made that likely, and they compound:

       - The file was sent exactly as the phone gave it. An iPhone hands over
         HEIC, and ImgBB does not accept HEIC — iOS usually converts to JPEG
         on the way out of the picker, but not always, which is exactly the
         shape of an intermittent failure.

       - No size limit. A modern phone photo is 4-8MB, and on mobile data
         that is a slow upload with plenty of time for the connection to drop.

       - No retry. One dropped connection and the shopper had to start again.

       - A failure cleared the chosen image, so they lost their place too.

     Now: every file is re-encoded to JPEG through a canvas first, which
     normalises the format and cuts the size, and a failed upload is retried
     once before giving up.
     ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------
     Where artwork is sent

     Was ImgBB. Two problems with that: the API key sat in this file where
     anyone could read it, and some UK mobile networks and ad blockers block
     imgbb outright — for those shoppers the upload could never finish, which
     is what the session recordings were showing.

     It now goes to our own endpoint. cfg.uploadUrl wins if the snippet ever
     starts printing one, so the address can move without touching this file.
     ------------------------------------------------------------------ */
  var UPLOAD_URL_DEFAULT = 'https://threesixtydigital.tech/us-clothing-uploads/upload.php';

  function uploadUrl() {
    return (cfg && cfg.uploadUrl) || UPLOAD_URL_DEFAULT;
  }

  /* 3000px on the longest edge. A twelve-inch DTG print at that size is
     around 250dpi, which is past the point where the press can resolve any
     more detail, so nothing visible is lost on the garment. */
  var UPLOAD_MAX_PX = 3000;

  /* Below this, the file is sent exactly as the shopper chose it. Touching a
     file that is already a sensible size can only lose quality, never add
     any. */
  var UPLOAD_SKIP_BYTES = 4 * 1024 * 1024;

  /* ------------------------------------------------------------------
     Preparing the file

     Three things this has to get right:

       - Transparency. The old code drew every image onto a white canvas and
         saved JPEG, so a logo with a transparent background came out with a
         white box behind it and printed that way. PNG and WEBP now stay in
         their own format.

       - HEIC. An iPhone sometimes hands over HEIC, which no browser canvas
         can read. Those fall through untouched and the server sorts them out.

       - Doing nothing when nothing is needed. A 2MB 2400px photo is already
         fine for print, so it is sent as it is.
     ------------------------------------------------------------------ */
  function prepare(file) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file);
      var img = new Image();

      img.onload = function () {
        try {
          var big = Math.max(img.width, img.height);

          /* Already a sensible size — send the shopper's own file. */
          if (big <= UPLOAD_MAX_PX && file.size <= UPLOAD_SKIP_BYTES) {
            URL.revokeObjectURL(url);
            resolve(file);
            return;
          }

          var scale = Math.min(1, UPLOAD_MAX_PX / big);
          var c = document.createElement('canvas');
          c.width  = Math.max(1, Math.round(img.width * scale));
          c.height = Math.max(1, Math.round(img.height * scale));

          var ctx = c.getContext('2d');
          var keepAlpha = /png|webp/i.test(file.type || '');

          if (!keepAlpha) {
            /* JPEG has no transparency, so give it a white base rather than
               the black one an empty canvas would produce. */
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, c.width, c.height);
          }
          ctx.drawImage(img, 0, 0, c.width, c.height);

          URL.revokeObjectURL(url);

          var type = keepAlpha ? 'image/png' : 'image/jpeg';
          var name = keepAlpha ? 'artwork.png' : 'artwork.jpg';

          c.toBlob(function (blob) {
            /* If the re-encode somehow grew the file, the original was
               better. Keep whichever is smaller. */
            if (!blob || blob.size >= file.size) { resolve(file); return; }
            resolve(new File([blob], name, { type: type }));
          /* 0.88, not 0.92. Measured on the same 6000x4000 photo: 515 KB at
             0.92 against 395 KB at 0.88, with no difference the eye can find
             at print size — JPEG spends most of its last few points of
             quality on detail a DTG press cannot reproduce anyway. The
             smaller file is worth it: it is a quarter less to send on mobile
             data, and PNG artwork is untouched by this. */
          }, type, 0.88);
        } catch (e) {
          URL.revokeObjectURL(url);
          resolve(file);
        }
      };

      /* A format the browser itself cannot read — send it as it is and let
         the server decide. */
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  function postToUploader(file, onProgress) {
    return new Promise(function (resolve, reject) {
      var fd = new FormData();
      fd.append('image', file);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', uploadUrl());

      xhr.upload.onprogress = function (e) {
        if (!onProgress) return;
        onProgress(e.lengthComputable ? Math.round((e.loaded / e.total) * 100) : null);
      };

      xhr.onload = function () {
        var data;
        try { data = JSON.parse(xhr.responseText); } catch (err) { data = null; }
        if (xhr.status >= 200 && xhr.status < 300 && data && data.success && data.url) {
          if (onProgress) onProgress(100);
          resolve(data.url);
        } else {
          reject(new Error((data && data.error) || 'upload rejected'));
        }
      };
      xhr.onerror   = function () { reject(new Error('network error')); };
      xhr.ontimeout = function () { reject(new Error('timed out')); };

      /* 60s, not the old 120s. Files are much smaller now, so anything still
         running after a minute is a broken connection rather than a slow one,
         and the retry is better spent than the wait. */
      xhr.timeout = 60000;
      xhr.send(fd);
    });
  }

  function uploadImage(file, onProgress) {
    if (!uploadUrl()) return resize(file, 900);

    return prepare(file).then(function (ready) {
      return postToUploader(ready, onProgress).catch(function () {
        /* One retry. A dropped connection on mobile data is common enough
           that asking the shopper to choose the file again for it is not
           reasonable. */
        if (onProgress) onProgress(0);
        return postToUploader(ready, onProgress);
      });
    });
  }

  function resize(file, max) {
    return new Promise(function (res, rej) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var s = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * s);
        c.height = Math.round(img.height * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        res(c.toDataURL('image/jpeg', 0.82));
      };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('bad image')); };
      img.src = url;
    });
  }

  /* ------------------------------------------------------------ add to cart */

  /* ------------------------------------------------------------------
     Variant selection

     Size and colour used to be chosen on the product page and read back off
     its form. They now live in the modal instead, so the form is hidden and
     would sit on whatever variant loaded first — the wizard has to resolve
     the variant itself from the options the shopper picks.
     ------------------------------------------------------------------ */
  var chosenOptions = [];

  /* which location the review step is previewing */
  var reviewLoc = null;

  function initOptions() {
    chosenOptions = [];
    var start = (cfg.variants || []).filter(function (v) {
      return String(v.id) === String(cfg.selectedVariantId);
    })[0] || (cfg.variants || [])[0];
    if (start) chosenOptions = start.options.slice();
  }

  /* The theme's own swatch styling keys off a handleized value. */
  function handleize(v) {
    return String(v).toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isColourOption(name) {
    return /colou?r/i.test(String(name));
  }

  function variantFor(opts) {
    var list = cfg.variants || [];
    for (var i = 0; i < list.length; i++) {
      var ok = true;
      for (var k = 0; k < opts.length; k++) {
        if (list[i].options[k] !== opts[k]) { ok = false; break; }
      }
      if (ok) return list[i];
    }
    return null;
  }

  /* Is this value reachable at all, given what is chosen for the other
     options? Lets a sold-out combination be shown as unavailable rather
     than letting the shopper pick it and fail at add to cart. */
  function valueAvailable(optIndex, value) {
    var probe = chosenOptions.slice();
    probe[optIndex] = value;
    var list = cfg.variants || [];
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (!v.available) continue;
      var ok = true;
      for (var k = 0; k < probe.length; k++) {
        if (k === optIndex) { if (v.options[k] !== value) { ok = false; break; } continue; }
        if (v.options[k] !== probe[k]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function currentVariantId() {
    var v = variantFor(chosenOptions);
    if (v) return v.id;
    var f = document.querySelector('form[data-type="add-to-cart-form"]');
    var i = f && f.querySelector('[name="id"]');
    return i ? i.value : null;
  }

  function currentQty() {
    var q = document.querySelector('form[data-type="add-to-cart-form"] [name="quantity"]');
    return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
  }

  /* ==================================================================
     Cart preview image

     Shopify takes a line item's image from the variant and will not accept
     another, so the cart would show the plain garment however the shopper
     designed it. The cart page is ours though, so: draw the garment and the
     artwork onto a canvas, upload it, and hand the URL to the cart page to
     swap in.

     Front wins when there is one; otherwise whichever side was customised.
     Checkout is Shopify's own page and still shows the variant image — that
     part is not ours to change.
     ================================================================== */

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('image blocked')); };
      img.src = src;
    });
  }

  /* Which side to show in the cart. */
  function compositeSide() {
    if (chosen.indexOf('front') > -1) return 'front';
    for (var i = 0; i < chosen.length; i++) {
      if (design[chosen[i]] && (design[chosen[i]].text || design[chosen[i]].image)) return chosen[i];
    }
    return chosen[0] || null;
  }

  function buildComposite() {
    var key = compositeSide();
    if (!key) return Promise.resolve(null);

    var d = design[key];
    if (!d || (!(d.text || '').trim() && !d.image)) return Promise.resolve(null);

    var side = sideFor(key);
    var base = baseImageFor(side);
    if (!base) return Promise.resolve(null);   /* no blank photo — nothing to draw on */

    var Z = zonePct(key, d.position);

    return loadImage(base).then(function (garmentImg) {
      var W = 700;
      var H = Math.round(W * (garmentImg.naturalHeight / garmentImg.naturalWidth)) || 700;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var ctx = c.getContext('2d');
      ctx.drawImage(garmentImg, 0, 0, W, H);

      /* The canvas has to lay things out the same way the CSS does, or the
         cart thumbnail shows a different design from the one the shopper
         approved. Matching the rules in customise-wizard.css:

           .cw-photo__zone  height 38% of the photo, artwork anchored to the
                            TOP of it, contents centred horizontally
           .cw-photo__art   scaled to fit the zone width, aspect kept
           .cw-photo__text  sits under the image unless the layout says
                            otherwise                                        */
      var zw = W * (Z.w / 100);
      var zh = H * (zoneHeight(Z.w) / 100);
      var zx = W * (Z.x / 100);
      var zTop = H * (Z.y / 100);              /* y is the top of the print area */

      var artUrl = d.image && (d.image.url || d.image.preview);
      var text = (d.text || '').trim();
      var col = d.colour ? colourByName(d.colour) : null;
      var f = d.font ? fontByName(d.font) : FONTS[0];

      /* Matches the CSS: text is sized against the print width and takes at
         most 40% of the print height, so the image always keeps the rest.

         With line breaks the same budget is shared between the lines, and
         the block the layout has to make room for is taller than one line.
         A single line is left exactly as it was, so nothing changes for the
         products already selling. */
      var textLines = text ? text.split('\n') : [];
      var lineCount = Math.max(1, textLines.length);

      function lineSize() {
        if (!text) return 0;
        var byWidth = zw * 0.15;
        var cap = zh * (artUrl ? 0.40 : 1);
        if (lineCount === 1) return Math.min(byWidth, cap);
        return Math.min(byWidth, cap / (1.3 * lineCount));
      }

      function textHeight() {
        if (!text) return 0;
        return lineCount === 1 ? lineSize() : lineSize() * 1.3 * lineCount;
      }

      /* cy is the middle of the whole text block; size is one line.

         fillText knows nothing about line breaks — given two lines it draws
         them as one, so the thumbnail in the cart would show a different
         design from the one the shopper approved on screen. Each line is
         drawn itself, stacked around the centre. */
      function drawText(cy, size) {
        if (!text) return;
        ctx.font = '700 ' + Math.round(size) + 'px ' +
                   (f && f.name ? "'" + f.name + "', " : '') + 'sans-serif';
        ctx.fillStyle = col ? col.hex : '#111827';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        if (lineCount === 1) { ctx.fillText(text, zx, cy, zw); return; }

        var lh = size * 1.3;
        var top = cy - ((lineCount - 1) * lh) / 2;
        for (var i = 0; i < textLines.length; i++) {
          ctx.fillText(textLines[i], zx, top + i * lh, zw);
        }
      }

      var artPromise = artUrl ? loadImage(artUrl).catch(function () { return null; })
                              : Promise.resolve(null);

      return artPromise.then(function (art) {
        var th = textHeight();
        var gap = zh * 0.04;

        if (art) {
          /* how tall the artwork can be, once the text has had its share */
          var room = zh - (text ? th + gap : 0);
          var aw = zw;
          var ah = aw * (art.naturalHeight / art.naturalWidth);
          if (ah > room) { ah = room; aw = ah * (art.naturalWidth / art.naturalHeight); }

          if (text && d.layout === 'text-over') {
            ctx.drawImage(art, zx - aw / 2, zTop, aw, ah);
            drawText(zTop + ah / 2, lineSize());
          } else if (text && d.layout === 'text-above') {
            drawText(zTop + th / 2, lineSize());
            ctx.drawImage(art, zx - aw / 2, zTop + th + gap, aw, ah);
          } else {
            /* image above text — the default */
            ctx.drawImage(art, zx - aw / 2, zTop, aw, ah);
            if (text) drawText(zTop + ah + gap + th / 2, lineSize());
          }
        } else {
          drawText(zTop + th / 2, lineSize());
        }

        return new Promise(function (resolve) {
          try {
            c.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', 0.86);
          } catch (e) {
            resolve(null);   /* tainted canvas — give up quietly */
          }
        });
      });
    }).then(function (blob) {
      if (!blob) return null;
      var file = new File([blob], 'preview.jpg', { type: 'image/jpeg' });
      return uploadImage(file).catch(function () { return null; });
    }).catch(function () {
      return null;           /* never let this stop an add to cart */
    });
  }

  function addToCart() {
    if (busy) return;
    var variantId = currentVariantId();
    if (!variantId) { els.err.textContent = 'Pick a colour and size first.'; return; }

    busy = true;
    els.next.disabled = true;
    els.next.textContent = 'Adding…';

    var qty = currentQty();
    var props = {};
    var state = {};

    /* Ties the add-on lines to THIS line. The product title isn't enough —
       the same product can sit in the cart twice with different designs. */
    var designId = 'cw-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);

    chosen.forEach(function (k) {
      var l = locByKey(k), d = design[k];
      if (d.position) props[l.label + ' — Position'] = d.position;
      if (d.text)     props[l.label + ' — ' + TEXT_LABEL] = d.text;
      if (d.text && d.font)   props[l.label + ' — Font'] = d.font;
      if (d.text && d.colour) props[l.label + ' — Font colour'] = d.colour;
      if (d.image)    props[l.label + ' — Image'] = d.image.url;
      if (d.layout)   props[l.label + ' — Layout'] = LAYOUTS.filter(function (x) { return x.id === d.layout; })[0].label;
      state[k] = { position: d.position, text: d.text, font: d.font, colour: d.colour,
                   layout: d.layout, image: d.image ? d.image.url : null };
    });
    props._design_state = JSON.stringify(state);
    props._design_id = designId;

    /* Build the cart thumbnail first, then send everything in one request.
       It is wrapped so a failure — a blocked image, a slow upload, a browser
       that taints the canvas — cannot stop the item reaching the cart. The
       cart simply falls back to the product photo. */
    els.next.textContent = 'Preparing…';

    buildComposite().then(function (previewUrl) {
      if (previewUrl) props._preview_image = previewUrl;
      els.next.textContent = 'Adding…';
      submitToCart(variantId, qty, props, designId);
    });
  }

  function submitToCart(variantId, qty, props, designId) {
    var items = [{ id: Number(variantId), quantity: qty, properties: props }];

    chosen.forEach(function (k) {
      var l = locByKey(k);
      if (!l.price || !l.variantId) return;
      items.push({
        id: Number(l.variantId),
        quantity: qty,
        properties: {
          _addon_of: designId,
          _addon_for: cfg.productTitle,
          'Print location': l.label
        }
      });
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        busy = false;
        els.next.disabled = false;
        els.next.textContent = txt('addToCart');
        els.err.textContent = err.message || 'Could not add to cart. Please try again.';
      });
  }

  /* ------------------------------------------------------------ open/close */

  function open() {
    initOptions();
    reviewLoc = null;
    initPreviewToggle();
    loadFonts();

    design = {}; idx = 0; busy = false;

    /* A location that costs nothing is one the shopper almost always wants,
       and leaving it unticked made the first step look like a wall of
       choices rather than a starting point. Free ones start selected; paid
       ones stay off so nothing is added without being asked for.

       This has to come after the reset below it used to sit above — the
       plain `chosen = []` wiped it on every open. */
    chosen = (cfg.locations || [])
      .filter(function (l) { return !l.price; })
      .map(function (l) { return l.key; });

    els.next.disabled = false;
    buildSteps();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    render();
  }
  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  /* ------------------------------------------------------------------- boot */

  function swapButton() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var done = false;

    Array.prototype.forEach.call(forms, function (form) {
      var subs = form.querySelectorAll('.product-form__submit:not(.cw-trigger)');
      if (!subs.length) return;

      /* Every real submit on the page goes — the main form, its duplicate,
         and the sticky bar. Leaving any one visible lets a shopper add the
         item with no design at all. */
      Array.prototype.forEach.call(subs, function (s) {
        s.hidden = true;
        s.style.display = 'none';
      });

      if (!form.querySelector('.cw-trigger')) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = subs[0].className + ' cw-trigger';
        btn.innerHTML = '<span>' + esc(txt('triggerButton')) + '</span>';

        /* Tracking hooks. Google Tag Manager can trigger on
           [data-cw-event="open_personaliser"] without any further code here,
           and the product id and title come along for the event payload. */
        btn.setAttribute('data-cw-event', 'open_personaliser');
        btn.setAttribute('data-cw-product-id', cfg.productId);
        btn.setAttribute('data-cw-product', cfg.productTitle || '');

        btn.addEventListener('click', open);
        subs[0].parentNode.insertBefore(btn, subs[0]);
      }

      var dyn = form.querySelector('.product-form__buttons--payment, .shopify-payment-button');
      if (dyn) dyn.style.display = 'none';

      done = true;
    });

    if (done) document.body.classList.add('cw-active');
    return done;
  }

  function boot() {
    cfg = readConfig();
    if (!cfg || !cfg.locations || !cfg.locations.length) return;

    FONTS   = parseFonts(cfg.fonts);
    COLOURS = parseColours(cfg.colours);
    cfg.allowText  = isTrue(cfg.allowText);
    cfg.allowImage = isTrue(cfg.allowImage);
    if (!cfg.allowText && !cfg.allowImage) return;

    modal = document.getElementById('CustomiseModal');
    if (!modal) return;
    body = modal.querySelector('[data-cw="body"]');   /* the controls panel */
    ['sub', 'bar', 'crumbs', 'err', 'back', 'next', 'close',
     'preview', 'bodywrap', 'badge', 'stage', 'viewcap'].forEach(function (k) {
      els[k] = modal.querySelector('[data-cw="' + k + '"]');
    });

    els.close.addEventListener('click', close);
    /* Clicking outside used to close the modal. On a design that took five
       steps to fill in, one stray tap threw all of it away — so only the
       cross closes it now. Escape is left out for the same reason: it is too
       easy to hit while typing. */
    els.back.addEventListener('click', function () { if (idx > 0) { idx--; render(); } });
    els.next.addEventListener('click', function () {
      if (!validate()) return;
      if (steps[idx].kind === 'review') { addToCart(); return; }
      idx++; render();
    });

    /* Bounded retry for the first paint. */
    var tries = 0;
    var iv = setInterval(function () {
      if (swapButton() || ++tries > 40) clearInterval(iv);
    }, 150);

    ['change', 'variant:change'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target && e.target.closest && e.target.closest('product-info, .product__info-container')) {
          setTimeout(swapButton, 60);
        }
      }, true);
    });

    watchProductArea();
    document.addEventListener('shopify:section:load', function () { setTimeout(swapButton, 80); });
  }

  /* The theme re-renders the product form after load — later on mobile than
     on desktop, which is why the button vanished there. Watch ONLY the
     product containers, throttled. A page-wide observer here fought with the
     app widgets and froze the page, so keep the scope tight. */
  function watchProductArea() {
    var hosts = document.querySelectorAll(
      'product-info, .product__info-container, [class*="sticky-cart"]'
    );
    if (!hosts.length) return;

    var pending = false;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; swapButton(); }, 80);
    });

    Array.prototype.forEach.call(hosts, function (h) {
      obs.observe(h, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();